import { Box } from '@apia/theme';
import { TTreeLabelRenderer } from '../../../common/generic/tree/types';
import { TNodeProps } from './Tree';

const LabelRenderer: TTreeLabelRenderer<TNodeProps> = (props) => {
  return (
    <Box
      as="span"
      className={`${props.nodeProps.className ?? ''} tree__mainLabel`}
    >
      {props.label}
    </Box>
  );
};

export default LabelRenderer;
